import { GrossProfitItemLabelTextHelper } from '../labelTextHelper/GrossProfitItemLabelTextHelper';
import { HeaderItem } from '../../model/HeaderItem';

export const GrossProfitItemHeaderHelper = {
    getHeaderItems(): HeaderItem[] {
        return [
            { text: GrossProfitItemLabelTextHelper.getLabelText.productId, value: 'productId' },
            { text: GrossProfitItemLabelTextHelper.getLabelText.quantity, value: 'quantity' },
            {
                text: GrossProfitItemLabelTextHelper.getLabelText.productCostAmountBaseCurrency,
                value: 'productCostAmountBaseCurrency'
            },
            {
                text: GrossProfitItemLabelTextHelper.getLabelText.itemUnitPriceAmountBaseCurrency,
                value: 'itemUnitPriceAmountBaseCurrency'
            },
            {
                text: GrossProfitItemLabelTextHelper.getLabelText.itemUnitGrossProfitAmountBaseCurrency,
                value: 'itemUnitGrossProfitAmountBaseCurrency'
            }
        ];
    },

    getHeaders() {
        return [...this.getHeaderItems()];
    }
};
